import { render, staticRenderFns } from "./UnlockRule.vue?vue&type=template&id=540cffce&scoped=true&"
import script from "./UnlockRule.vue?vue&type=script&lang=js&"
export * from "./UnlockRule.vue?vue&type=script&lang=js&"
import style0 from "./UnlockRule.vue?vue&type=style&index=0&id=540cffce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540cffce",
  null
  
)

export default component.exports